import { FC, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { TAdminType, TModalState } from '../../types.ts';
import { normalizeData } from '../../utils/normalize-data.ts';
import { AdminDelete } from '../delete';
import { normalizeDefaultValues } from '../form';
import { AdminUpdate } from '../update';

import { useColumns } from './hooks/use-columns.tsx';

import { API } from '@/services/api';
import { PaginatedTable } from '@/widgets/paginated-table';

export const AdminsTable: FC = () => {
    const [record, setRecord] = useState<TAdminType | null>(null);
    const [modalState, setModalState] = useState<TModalState>({
        update: false,
        delete: false,
    });

    const { data, isLoading, isPending } = useQuery({
        ...API.ADMINS.getAdmins(),
    });

    const handleDeleteClose = (): void => {
        setModalState((prev) => ({ ...prev, delete: false }));
    };
    const handleUpdateClose = (): void => {
        setModalState((prev) => ({ ...prev, update: false }));
    };

    const columns = useColumns({ setModalState, setRecord });

    return (
        <>
            <PaginatedTable
                loading={isPending || isLoading}
                total={data?.result.length || 0}
                columns={columns}
                dataSource={normalizeData(data?.result || [])}
            />
            <AdminDelete record={record} open={modalState.delete} onClose={handleDeleteClose} />
            <AdminUpdate
                id={record?.id || 0}
                initialValues={normalizeDefaultValues(record)}
                open={modalState.update}
                onClose={handleUpdateClose}
            />
        </>
    );
};
